import {useCallback} from 'react';
import {useAuth} from 'react-oidc-context';
import type {GetTokens} from 'api/types';

export const useGetTokens = (): GetTokens => {
  const auth = useAuth();

  return useCallback(
    () =>
      Promise.resolve({
        accessToken: auth.user?.access_token || '',
        idToken: auth.user?.id_token || '',
      }),
    [auth.user?.access_token, auth.user?.id_token],
  );
};
